import {AbstractControl, ValidationErrors} from "@angular/forms";

export function containsLowercaseValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value || /[a-z]/.test(control.value)) {
    return null;
  }

  control.setErrors({containsLowercase: true});
  return {containsLowercase: true};
}
